import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { ReactComponent as MainLogo } from "../../../media/icons/mainLogo.svg";
import styles from "./logo.module.css";

export const Logo = () => {
  const { t } = useTranslation();

  return (
    <Link to="/" className={styles.logoLink} aria-label={t("dashboard_nav_home")}>
      <MainLogo className={styles.mainLogo} aria-hidden="true" focusable="false" />
    </Link>
  );
};
